import { render, staticRenderFns } from "./FormPageDictionary.vue?vue&type=template&id=714ba73f&"
import script from "./FormPageDictionary.vue?vue&type=script&lang=js&"
export * from "./FormPageDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('714ba73f')) {
      api.createRecord('714ba73f', component.options)
    } else {
      api.reload('714ba73f', component.options)
    }
    module.hot.accept("./FormPageDictionary.vue?vue&type=template&id=714ba73f&", function () {
      api.rerender('714ba73f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dictionary/form/FormPageDictionary.vue"
export default component.exports